import i18n from '../i18nService';
import { recipesService } from './recipesService';

export const recipeNamesService = {
    getLocalization(localeCode, recipe, withCodeReplace = false, i18nInstance = i18n) {
        const localizedName = recipe?.names?.find((it) => it.locale === localeCode)?.name;
        if (localizedName) {
            return localizedName;
        }
        if (withCodeReplace && recipe?.recipeType) {
            return recipesService.getLocalization(localeCode, recipe.recipeType, true, i18nInstance);
        }
        return withCodeReplace ? (recipe?.recipeCode || recipe?.id || '') : '';
    },
    getPlaceholder(i18nInstance = i18n) {
        return i18nInstance.t('app.page.recipe.recipeName');
    },
};
